/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DriverTeamAdminDto } from '../models/DriverTeamAdminDto';
import type { Pagination1OfDriverTeamListedAdminDto } from '../models/Pagination1OfDriverTeamListedAdminDto';
import type { PostDriverTeamAdminRequest } from '../models/PostDriverTeamAdminRequest';
import type { UpdateDriverTeamAdminRequest } from '../models/UpdateDriverTeamAdminRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DriverTeamsService {
    /**
     * **Required Policy:** `ManageDriverTeams`
     * @returns DriverTeamAdminDto Created
     * @throws ApiError
     */
    public static postDriverTeamAdmin({
        requestBody,
    }: {
        requestBody?: PostDriverTeamAdminRequest,
    }): CancelablePromise<DriverTeamAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driver-teams',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverTeams`
     * @returns Pagination1OfDriverTeamListedAdminDto OK
     * @throws ApiError
     */
    public static getDriverTeamsAdmin({
        id,
        driverId,
        channelId,
        name,
        searchWord,
        page,
        limit,
    }: {
        id?: number,
        driverId?: number,
        channelId?: number,
        name?: string,
        searchWord?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfDriverTeamListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driver-teams',
            query: {
                'id': id,
                'driverId': driverId,
                'channelId': channelId,
                'name': name,
                'searchWord': searchWord,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverTeamDetails`
     * @returns DriverTeamAdminDto OK
     * @throws ApiError
     */
    public static getDriverTeamAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<DriverTeamAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driver-teams/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverTeams`
     * @returns DriverTeamAdminDto OK
     * @throws ApiError
     */
    public static putDriverTeamAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: UpdateDriverTeamAdminRequest,
    }): CancelablePromise<DriverTeamAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/driver-teams/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteDriverTeams`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteDriverTeamAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/driver-teams/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverTeams`
     * @returns DriverTeamAdminDto OK
     * @throws ApiError
     */
    public static postDriverTeamDriverAdmin({
        id,
        driverId,
    }: {
        id: number,
        driverId: number,
    }): CancelablePromise<DriverTeamAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driver-teams/{id}/drivers/{driverId}',
            path: {
                'id': id,
                'driverId': driverId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverTeams`
     * @returns DriverTeamAdminDto OK
     * @throws ApiError
     */
    public static deleteDriverTeamDriverAdmin({
        id,
        driverId,
    }: {
        id: number,
        driverId: number,
    }): CancelablePromise<DriverTeamAdminDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/driver-teams/{id}/drivers/{driverId}',
            path: {
                'id': id,
                'driverId': driverId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverTeams`
     * @returns DriverTeamAdminDto OK
     * @throws ApiError
     */
    public static postDriverTeamChannelAdmin({
        id,
        channelId,
    }: {
        id: number,
        channelId: number,
    }): CancelablePromise<DriverTeamAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driver-teams/{id}/channels/{channelId}',
            path: {
                'id': id,
                'channelId': channelId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverTeams`
     * @returns DriverTeamAdminDto OK
     * @throws ApiError
     */
    public static deleteDriverTeamChannelAdmin({
        id,
        channelId,
    }: {
        id: number,
        channelId: number,
    }): CancelablePromise<DriverTeamAdminDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/driver-teams/{id}/channels/{channelId}',
            path: {
                'id': id,
                'channelId': channelId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
